import { render, staticRenderFns } from "./ColumDetails.vue?vue&type=template&id=0ced9c2c&scoped=true&"
import script from "./ColumDetails.vue?vue&type=script&lang=js&"
export * from "./ColumDetails.vue?vue&type=script&lang=js&"
import style0 from "./ColumDetails.vue?vue&type=style&index=0&id=0ced9c2c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ced9c2c",
  null
  
)

export default component.exports